import store from '../store';
import { setFirebaseNotification } from '../store/actions/firebasenotification.actions';

const createFirebaseNotification = (title: any, text: any, status: 'default' | 'test', image?: any) => {
  store.dispatch(setFirebaseNotification({ title, text, status, image, date: Date.now() }));
};

export {
  createFirebaseNotification,
};